// 格式化日期
export function formateDate(value) {
    if(value){
        return value.split(' ')[0]
    }
    return '--'
}


// WEBPACK FOOTER //
// ./src/filters/index.js